import { ApiClientProps } from "hooks/useApi";

interface GetToastChitsParams {
    apiClient: ApiClientProps;
    locationId?: string;
    partnerId?: string;
}

const getToastChits = async ({ apiClient, locationId, partnerId }: GetToastChitsParams) => {
    if (!locationId || !partnerId) {
        throw new Error("Location ID and Partner ID are required to fetch Toast Chits data.");
    }

    try {
        const response = await apiClient.get({
          path: `/middleware-admin/partners/${partnerId}/locations/${locationId}/gda`,
          noRetry: true
        });

        return response;
    } catch (error) {
        throw new Error(error as string);
    }
};

export default getToastChits;